<template>
  <div>
    <div>
      <div class="header_margin">      
      </div>    
    </div>
    <div align="center" justify="center">      
      <div class="text-center" id="blinking">
        <h2 id="typing-demo" class="white--text mt-8 mb-1  font-weight-light">FAST SECURE MESSENGER</h2>
        <img                    
          src="../assets/karmalog2.png"           
          width="250px"          
        />
      </div>      
    </div>
    <div >
      <div class="header_margin">      
      </div>
    </div>
    <div id="scoll_get" align="center" justify="center" >
      <div  align="center" class="content_get ">
        <div class="mt-7 flex" >
          <h1>Get KARMA</h1>
        </div>
        <div id ="line-height" class="ml-10 mr-10 mt-5 mb-5" >
          <div >사진, 동영상, 파일까지 암호화하는 철통 보안 메신저! <br>       
          내 메시지의 보존과 암호화를 내가 통제하는 안전한 메시징을 무료로 즐겨보세요.
          </div>        
        </div>
        <div class="mt-10 mb-10">
          <v-btn class="ma-2" outlined color="black" href="https://play.google.com/store/apps/details?id=me.karmalab.talk" target="_blank"><v-icon class="mr-1" >mdi-google-play</v-icon>GOOGLE PLAY</v-btn>        
          <v-btn class="ma-2" outlined color="black" href="https://apps.apple.com/us/app/id1525173248" target="_blank"><v-icon class="mr-1">mdi-apple</v-icon>APP STORE</v-btn>         
          <v-btn class="ma-2" outlined color="black" href="http://www.karmalab.me/download/KarmaPCMessenger.exe" target="_blank"><v-icon class="mr-1">mdi-windows</v-icon>Windows</v-btn>         
          <v-btn class="ma-2" outlined color="black" href="http://www.karmalab.me/download/KarmaPCMessenger.dmg" target="_blank"><v-icon class="mr-1">mdi-desktop-mac</v-icon>MAC</v-btn>                   
        </div>
      </div>
    </div>


    <div id="scoll_why">      
      <div align="center" class="content_why">
        <div class="pt-10">
          <h1 class="white--text">Why KARMA</h1>
        </div>
        <v-container fluid>
        <div
          class="flex"        
          flat        
          color="black"
        >
            <v-row
              color="black"              
              align="top"              
              justify="center"                            
            >
              <div id="item-box" class="ma-3 pa-6 white--text">
                <v-icon color="white" x-large>mdi-shield-outline</v-icon>
                <h2 class="mt-3 mb-3">동영상까지 암호화</h2>
                <div>
                텍스트 뿐만 아니라 사진, 동영상, 파일까지 암호화하여 당신의 메시지를 안전하게 지켜냅니다.
                </div>
              </div>
              <div id="item-box"  class="ma-3 pa-6 white--text">
                <v-icon color="white" x-large>mdi-play-protected-content</v-icon>
                <h2 class="mt-3 mb-3">내 콘텐츠는 내가 관리</h2>
                <div>
                메시지의 암호화, 재생, 보존을 내가 직접 관리할 수 있도록 자동삭제 타이머와 암호화 및 재생 유효기간 설정을 제공합니다.
                </div>
              </div>
              <div id="item-box"  class="ma-3 pa-6 white--text">
                <v-icon color="white" x-large>mdi-clock-fast</v-icon>
                <h2 class="mt-3 mb-3">눈부시게 빠른 속도</h2>
                <div>
                클라우드 기반의 서버와 대용량 메시징 기술을 적용하여 모든 메시지를 빠르게 전송합니다.
                </div>
              </div>
              
            </v-row>
           
        </div>  
        </v-container>      
      </div>
    </div>



    <div id="scoll_now" align="center" justify="center" >
      <div align="center" >
        <div class="mt-10">
          <h1 class="black--text">Now KARMA</h1>
        </div>
        <v-container fluid>
        <div
          class="flex"        
          flat        
          color="white"
        >
            <v-row
              color="white"              
              align="top"              
              justify="center"                            
            >
              <div id="item-box2" class="ma-3 pa-6 black--text">                
                <h1 class="font-weight-black mt-3 mb-3">FREELY</h1>
                <div>
                메시지 자동 삭제
                </div>
              </div>
              <div id="item-box2" class="ma-3 pa-6 black--text">                
                <h1 class="font-weight-black mt-3 mb-3">0.4S</h1>
                <div>
                메시지 전송속도
                </div>
              </div>
              <div id="item-box2" class="ma-3 pa-6 black--text">                
                <h1 class="font-weight-black mt-3 mb-3">1M+</h1>
                <div>
                동시접속
                </div>
              </div>
              <div id="item-box2" class="ma-3 pa-6 black--text">                
                <h1 class="font-weight-black mt-3 mb-3">20+</h1>
                <div>
                무료 이모티콘
                <v-btn class="ma-2" depressed href="http://www.karmalab.me/emoticon/" target="_blank"><v-icon class="mr-1">mdi-emoticon</v-icon>Topping</v-btn>
                </div>
              </div>
              
              
            </v-row>
           
        </div>  
        </v-container>      
      </div>
    </div>


    <div id="scoll_next">
      <div align="center" class="content_why">
        <div class="pt-10">
          <h1 class="white--text">Next KARMA</h1>
        </div>
        <v-container fluid>
        <div
          class="flex"        
          flat        
          color="black"
        >
            <v-row
              color="black"              
              align="top"              
              justify="center"                            
            >
              <div id="item-box" class="ma-3 pa-6 white--text">
                <v-icon color="white" x-large>mdi-share-variant</v-icon>
                <h2 class="mt-3 mb-3">Blockchain Messenger</h2>
                <div>
                메신저 플랫폼의 다양한 서비스 이용을 촉진하기 위한 보상 체계로 플랫폼 안에서만 사용 가능한 일종의 포인트와 유사한 블록체인 기반의 유틸리티 토큰을 제공할 수 있습니다. 이 토큰으로 서비스를 이용하고 아이템을 얻을 수 있으며 서로 주고 받을 수도 있을 것입니다. 블록체인 기반이므로 거래의 투명성과 안전성이 보장될 것입니다.
                </div>
              </div>
              <div id="item-box"  class="ma-3 pa-6 white--text">
                <v-icon color="white" x-large>mdi-account-group</v-icon>
                <h2 class="mt-3 mb-3">기업용 ERP Messenger</h2>
                <div>
                퍼블릭 메신저에서는 가급적 기록을 남기지 않도록 하여 사생활을 보호하는 것이 중요하지만 기업용 프라이빗 메신저에서는 기록을 충분히 남기되 위변조 없이 보존하는 것이 중요합니다. <br>메시징 내용을 블록체인에 기록하여 위변조를 방지하고 의사결정 과정을 쉽게 추적할 수 있게 하면 전자결재 등 기업의 중요 업무에도 메신저 활용이 가능해집니다.
                </div>
              </div>
              <div id="item-box"  class="ma-3 pa-6 white--text">
                <v-icon color="white" x-large>mdi-lan</v-icon>
                <h2 class="mt-3 mb-3">Untact Messenger</h2>
                <div>
                Untact 문화의 확산으로 재택근무, 원격협업이 더욱 많아지면서 기존의 메신저를 통한 기본적인 의사소통 뿐만 아니라 화상회의, 원격교육, Live방송, AR 등 Interactive한 UX에 대한 요구가 높아질 것입니다. 메시징 기반의 플랫폼 상에서 Untact에 필요한 서비스를 구현한다면 Contact 업무환경을 쉽게 대체할 수 있을 것입니다.
                </div>
              </div>
              
            </v-row>
           
        </div>  
        </v-container>      
      </div>
    </div>


    <div id="scoll_about" align="center" justify="center" >
      <div align="center" >                
          <v-img
            class="white--text align-top"
            height="300px"        
            src="../assets/logo_wide.jpg"           
          >
          <h1 class="mt-7 white--text">About KARMA</h1>
          <div id="content_about" class="white--text" >
카르마의 어원은 고대어로부터 유래합니다.<br>
‘카르’는 칸, 한, 빛, 신, 왕, 칼(신의 선물)을 의미합니다. 
‘마’는 위대하다, 거칠다 를 의미합니다.<br>
카르마는 위대한 신, 위대한 왕, 위대한 빛을 상징합니다.
          </div>
        </v-img>               
      </div>
    </div>

    <div id="scoll_contact" align="center" justify="center" >
      <div align="center" >
        <div class="mt-7">
          <h1 class="black--text">Contact KARMA</h1>
        </div>
        <v-container fluid>
        <div
          class="flex"        
          flat        
          color="white"
        >
            <v-row
              color="white"              
              align="center"              
              justify="center"                            
            >
              <div id="item-box3" class="ma-3 pa-6 black--text">                
                <div>info@karmalab.me<br></div>
                <div>+82 02-558-2300<br></div>
                <div>주식회사 카르마랩<br></div>
                <div>서울시 성동구 연무장길 76. 성수AK밸리 10층 1002호<br></div>
                <div>2호선 성수역 3번 출구에서 350m<br></div>
              </div>
              <div id="item-box3"  class="ma-3 pa-6 black--text">
                <img                      
                  src="../assets/map.png"           
                  width="320px"          
                />
              </div>              
              
            </v-row>
           
        </div>  
        </v-container>      
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({    
    dialog : false,
  }),

  methods: {    
    getDownload(sPath){
      axios({
      url: sPath, 
      method: 'GET',
      responseType: 'blob', 
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.jpg'); 
        document.body.appendChild(link);
        link.click();
      });      
    },
  }
}
</script>


<style scoped>
.header_margin {    
  width:100%;
  height:100px;  
}
/* .header_text {    
  background: #000000;   
} */
.content_get {    
  z-index: 2;
  width:100%;
  float:top;
  background: #FFFFFF;   
}
.content_why {    
  width:100%;  
  background: #2A2A2A;   
}


#content_about {    
  width:80%;    
  line-height:200%;
}

#line-height {
  line-height:200%;
}

#item-box {
  width:300px;
  line-height:200%;
}

#item-box2 {
  width:200px;
  line-height:200%;
}
#item-box3 {
  width:400px;
  line-height:200%;
}



#blinking{
	-webkit-animation:blink 3s ease-in-out infinite alternate;
    -moz-animation:blink 3s ease-in-out infinite alternate;
    animation:blink 3s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 



</style>

